import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'objectIntersect',
    pure: false
})
export class PipeObjectIntersect implements PipeTransform {
    transform(a: any[], b : any[]): any {
        var t;
        if (b.length > a.length) 
            t = b, b = a, a = t; // indexOf to loop over shorter
            
        return a.filter(function (e) {
            return b.indexOf(e) > -1;
        });
    }
}